const en = {
  Rezepte: 'Recipes',
  Spiele: 'Games',
  Zeitkapsel: 'Time Capsule',
  Musik: 'Music',
  Listen: 'Lists',
  Einstellungen: 'Settings',
  Theme: 'Theme',
  Sprache: 'Language',
  Hell: 'Light',
  Dunkel: 'Dark',
  System: 'System',
  Deutsch: 'German',
  Englisch: 'English',
  Schließen: 'Close',
  Chats: 'Chats',
  'Deine Listen': 'Your Lists',
  Willkommen: 'Welcome to Alica\'s Time Capsule',
  LoginText: 'Please log in or register to continue.',
  NochKeinAccount: 'No account yet? Register now',
  ZurueckZumLogin: 'Back to login',
  Wordle: 'Wordle',
  WordleDesc: 'Guess the word in 6 tries',
  NeuesSpiel: 'New Game',
  Ueberpruefen: 'Check',
  WordleHint: 'Type letters and press Enter to guess',
  WaehleDeinSpiel: 'Choose your game',
  NeueErinnerung: 'Add new memory',
  NachrichtFuerZukunft: 'Write a message for the future...',
  BildHochladen: 'Upload image',
  Vorschau: 'Preview',
  Abbrechen: 'Cancel',
  Speichern: 'Save',
  FehlerLaden: 'Error loading memories',
  FehlerSpeichern: 'Error saving memory',
  ErinnerungErfolg: 'Memory saved successfully!',
  BitteTextOderBild: 'Please add text and/or image.',
  GepostetVon: 'Posted by',
  Unbekannt: 'Unknown',
  MemoryBildAlt: 'Image',
  VorschauBildAlt: 'Preview',
  Datum: 'Date',
  Erinnerungen: 'Memories',
  Hinzufuegen: 'Add',
  Bild: 'Image',
  Text: 'Text',
  LadeErinnerungen: 'Loading memories...',
  NeuenSongPosten: 'Post new song',
  SpotifyLinkOderSongname: 'Spotify link or song name',
  Suchen: 'Search',
  KeinSongGefunden: 'No song found!',
  FehlerSpotifySuche: 'Error searching Spotify.',
  SongErfolgGepostet: 'Song posted successfully!',
  AufSpotifyOeffnen: 'Open on Spotify',
  Preview: 'Preview',
  Schliessen: 'Close',
  DeinBrowserUnterstuetztKeinAudio: 'Your browser does not support audio.',
  SongPosten: 'Post song',
  OffeneChatAnfragen: 'Open Chat Requests',
  Von: 'From',
  Annehmen: 'Accept',
  Ablehnen: 'Decline',
  DeineChats: 'Your Chats',
  NeuenChatStarten: 'Start New Chat',
  UsernameSuchen: 'Search username',
  ChatAnfrageSenden: 'Send Chat Request',
  ChatMit: 'Chat with',
  NachrichtSchreiben: 'Write message...',
  Senden: 'Send',
  Entfernen: 'Remove',
  WaehleChatOderStarteNeuen: 'Select a chat or start a new one!',
  Du: 'You',
  KeinUserGefunden: 'No user found!',
  DuKannstDichNichtSelbstSuchen: 'You cannot search for yourself!',
  EsExistiertBereitsEinChat: 'A chat or request already exists!',
  FehlerBeimSendenDerAnfrage: 'Error sending request!',
  AnfrageGesendet: 'Request sent!',
  DeineListen: 'Your Lists',
  NeueListeErstellen: 'Create new list',
  NameDerListe: 'List name',
  Erstellen: 'Create',
  Einladungen: 'Invitations',
  EinladungZu: 'Invitation to',
  Liste: 'List',
  NeuerPunkt: 'New item',
  MitgliederVerwalten: 'Manage members',
  Mitglieder: 'Members',
  Ersteller: 'Creator',
  Mitglied: 'Member',
  MitgliedDarfEinladen: 'Member (can invite)',
  MitgliedEntfernen: 'Remove member',
  DasIstDerErsteller: 'This is the creator of the list.',
  NeuesMitgliedEinladen: 'Invite new member',
  Username: 'Username',
  Einladen: 'Invite',
  UserNichtGefunden: 'User not found!',
  UserBereitsMitglied: 'User is already invited or a member!',
  EinladungVerschickt: 'Invitation sent!',
  ListeLoeschen: 'Delete list',
  MitgliedVerwalten: 'Manage member',
  DarfMitgliederEinladen: 'Can invite members',
  RezepteDurchsuchen: 'Search recipes...',
  Kategorie: 'Category',
  Alle: 'All',
  NeuesRezeptErstellen: 'Create new recipe',
  Titel: 'Title',
  Beschreibung: 'Description',
  Zubereitungszeit: 'Preparation time (minutes)',
  Kochzeit: 'Cooking time (minutes)',
  Portionen: 'Servings',
  Schwierigkeitsgrad: 'Difficulty',
  Einfach: 'Easy',
  Mittel: 'Medium',
  Schwer: 'Hard',
  Zutaten: 'Ingredients',
  Zutat: 'Ingredient',
  Menge: 'Amount',
  Einheit: 'Unit',
  ZutatHinzufuegen: 'Add ingredient',
  Zubereitungsschritte: 'Preparation steps',
  SchrittHinzufuegen: 'Add step',
  Kategorien: 'Categories',
  Titelbild: 'Main image',
  BildURL: 'Image URL',
  TitelbildVorschau: 'Main image preview',
  RezeptErstellen: 'Create recipe',
  RezeptErfolg: 'Recipe created successfully!',
  FehlerRezept: 'Error creating recipe',
  Min: 'min',
  portionenText: 'servings',
  BildURLOptional: 'Image URL (optional)',
  Schritt: 'Step',
  Kommentar: 'Comment',
  RezeptLiken: 'Like recipe',
  RezeptEntfernenLike: 'Remove like',
  KommentarOeffnen: 'Show comments',
  RezeptErstellenBtn: 'Create recipe',
  FehlerLadenRezepte: 'Error loading recipes',
  FehlerLadenKategorien: 'Error loading categories',
  Kommentare: 'Comments',
  NochKeineKommentare: 'No comments yet.',
  KommentarSchreiben: 'Write a comment...',
  SpeichernLaden: 'Saving...',
  Kommentieren: 'Comment',
  KommentarGespeichert: 'Comment saved!',
  FehlerKommentar: 'Error saving comment',
  KommentarHinzufuegen: 'Add comment',
  KommentarLoeschen: 'Delete comment',
  Kommentarbild: 'Comment image',
  Vorschau: 'Preview',
  KommentarbildAlt: 'Comment image',
  KommentarZeit: 'on',
  RezeptNichtGefunden: 'Recipe not found.',
  Zurueck: 'Back',
  Bearbeiten: 'Edit',
  Loeschen: 'Delete',
  ZubereitungMin: 'Preparation (min)',
  KochzeitMin: 'Cooking time (min)',
  Schwierigkeit: 'Difficulty',
  ErstelltVon: 'Created by',
  RezeptLoeschen: 'Delete recipe',
  RezeptLoeschenBestaetigung: 'Do you really want to delete this recipe? This action cannot be undone.',
  RezeptLoeschenWarnung: 'Delete recipe',
  RezeptAktualisiert: 'Recipe updated successfully!',
  FehlerAktualisieren: 'Error updating recipe',
  FehlerLoeschen: 'Error deleting recipe',
  Avatar: 'Avatar',
  KunstwerkDesTages: 'Artwork of the Day',
  MotivationDesTages: 'Motivation of the Day',
  FunFactDesTages: 'Fun Fact of the Day',
  FehlerLadenInspiration: 'Error loading inspiration',
  Kunstwerk: 'Artwork',
  Künstler: 'Artist',
  Zitat: 'Quote',
  ZitatAutor: 'Author',
  FunFact: 'Fun Fact',
  BildAlt: 'Artwork',
  BildOeffnen: 'Open image',
  InspirationDesTages: 'Inspiration of the Day',
  Datenschutzerklaerung: 'Privacy Policy',
  DatenschutzUebersicht: '1. Privacy at a glance',
  AllgemeineHinweise: 'General information',
  DatenschutzAllgemeinText: 'The following notes provide a simple overview of what happens to your personal data when you visit this website.',
  Datenerfassung: '2. Data collection on this website',
  Verantwortlicher: 'Who is responsible for data collection on this website?',
  VerantwortlicherText: 'Data processing on this website is carried out by the website operator. You can find their contact details in the imprint of this website.',
  WelcheDaten: '3. What data is collected?',
  WelcheDatenText: 'The following personal data is collected on this website:',
  WelcheDatenListe: 'Email address (for login/registration); Profile picture (optional); Username; Time capsule entries (messages, images, videos); Chat messages; Game data',
  Datenverarbeitung: '4. How is your data processed?',
  DatenverarbeitungText: 'We use Supabase as a database service. The privacy policy of Supabase can be found at:',
  Rechte: '5. Your rights',
  RechteText: 'You have the right at any time:',
  RechteListe: 'To receive information about your stored data; To have it corrected; To request deletion; To restrict processing; To object to processing; To receive your data in a structured format',
  Speicherdauer: '6. Storage duration',
  SpeicherdauerText: 'Your data will be stored as long as necessary for the stated purposes. You can delete your account at any time, which will delete all your personal data.',
  Cookies: '7. Cookies',
  CookiesText: 'This website only uses technically necessary cookies for the functionality of the website. No tracking cookies or third-party cookies are used.',
  Zurueck: 'Back',
  Impressum: 'Imprint',
  AngabenGemaess: 'Information according to § 5 TMG',
  Kontakt: 'Contact',
  VerantwortlichInhalt: 'Responsible for content according to § 55 Abs. 2 RStV',
  EUStreitschlichtung: 'EU Dispute Resolution',
  EUStreitschlichtungText: 'The European Commission provides a platform for online dispute resolution (ODR):',
  Verbraucherschlichtung: 'Consumer Dispute Resolution',
  VerbraucherschlichtungText: 'We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.',
  Datenschutz: 'Privacy Policy',
  DatenschutzText: 'This privacy policy will inform you about the data collection on this website, how we process your data, and your rights.'
};
export default en; 